import React from "react";
import TennetHome from "./LandingPage/Index";
import TennetCustody from "./CustodyPage/IndexCustody";
import TennetXcrow from "./XcrowPage/IndexXcrow";
import TenneOTC from "./OTCPage/IndexOTC";
import AboutUS from "./AboutUs/IndexAboutUs";
import WhyTennet from "./WhyTennet/IndexWhyTennet";
import BookMeeting from "./BookMeeting/IndexMeeting";
import UseCase from "./Solutions/IndexUseCase";
import SupportedCryptoList from "./CryptoList/IndexCryptoList";
import FAB from "./Components/FAB";

import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Terms from "./TermCondition/Terms";
import Privacy from "./TermCondition/Privacy";

function Main() {
  return (
    <div>
      <BrowserRouter>
        <FAB />
        <Routes>
          {/* LANDING PAGE */}
          <Route path="/" element={<Navigate to="/home" replace />} />
          <Route path="/home" element={<TennetHome />} />
          <Route path="/custody" element={<TennetCustody />} />
          <Route path="/xcrow" element={<TennetXcrow />} />
          <Route path="/otc" element={<TenneOTC />} />
          <Route path="/aboutus" element={<AboutUS />} />
          <Route path="/whytennet" element={<WhyTennet />} />
          <Route path="/bookmeeting" element={<BookMeeting />} />
          <Route path="/usecase" element={<UseCase />} />
          <Route path="/supported-coins" element={<SupportedCryptoList />} />

          {/* TERMS & CONDITIONS */}
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default Main;